import React, { Component } from "react";
import { Link } from "gatsby";

class HeroSection extends Component {
  state = {};
  render() {
    return (
      <section id="hero-section">
        <div className="container pt-5 my-pb">
          <div className="row pb-md-5">
            <div className="col-md-6 col-sm-12 my-hero-pt pr-3 pb-5">
              <p className="hero-desc">Innovative Business Thinking</p>
              <h1 className="head">Generating new business growth plans</h1>
              <p className="mb-5 hero-desc">
                Donec sollicitudin magnaultric semper. Lorem ipsum dolor sit
                amet consectetur.
              </p>
              <Link className="hero-cta-button" to="/">
                Get in Touch
              </Link>
            </div>
            <div className="col-md-6 col-sm-12">
              <img
                class="img-fluid"
                src={require("../../../static/images/home-banner-side-img1.png")}
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default HeroSection;
